import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { func, string, shape, node } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { MediaReviewCardComponent } from './media-review-card.styles';

const MediaReviewCard = _ref => {
  let {
    children,
    media,
    onClick,
    width,
    height
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "media", "onClick", "width", "height"]);

  const {
    mediaType,
    mediaUrl
  } = media;
  return /*#__PURE__*/React.createElement(MediaReviewCardComponent, _extends({
    "data-testid": `media-card-${mediaUrl}`,
    mediaUrl: mediaUrl,
    onClick: onClick,
    width: width,
    height: height
  }, props), mediaType === 'video' && /*#__PURE__*/React.createElement(Icon, {
    name: "VideoCircle",
    width: "40px",
    height: "40px"
  }), children);
};

process.env.NODE_ENV !== "production" ? MediaReviewCard.propTypes = {
  children: node,
  media: shape({
    mediaUrl: string,
    mediaType: string
  }),
  onClick: func,
  width: string,
  height: string
} : void 0;
export default MediaReviewCard;